import { Boggle } from "assets/icons";
import { InformationSetting } from "components/settings";
import { WidgetType } from "types/Widget";

import Boogle from "./Boogle";
import { BoogleSetting } from "./BoogleSetting";

export const BoogleWidget: WidgetType = {
  name: "Boggle",
  component: Boogle,
  icon: Boggle,
  showOnToolbar: true,
  sizing: {
    minWidth: 82,
    minHeight: 100,
    minAspectRatio: 0.82,
    maxAspectRatio: 0.82,
  },
  defaultState: {
    grid: 3,
    selectedIndex: null,
    selectedColor: {},
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 30,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Generate random letters in 3*3 or 4*4 or 5*5 grid.",
      },
    },
    grid: {
      defaultValue: { grid: 3, selectedIndex: null, selectedColor: {} },
      editor: BoogleSetting,
      info: {
        label: "Grid",
        rule: {
          label: "Rules",
          description: "Make as many words as you can.",
          variations: {
            label: "Game Variations",
            description:
              "Choose any letters squares to form words. Only use each letter square once.",
            subDescription: "Words must contain at least three letters.",
          },
          scoring: {
            label: "Scoring",
            points: {
              ["Less than 3 letters"]: "0 points",
              ["3 letters"]: "1 points",
              ["4 letters"]: "2 points",
              ["5 letters"]: "3 points",
              ["6 letters"]: "4 points",
              ["7 letters"]: "5 points",
              ["8 or more letters"]: "10 points",
            },
          },
          desclaimer:
            "Note: The letters in Boggle widget are generated at random, and the possible combinations per puzzle are not checked for undesirable word combinations.",
          subDesclaimer:
            "Please generate the puzzle and conduct your own check before presenting to your class.",
        },
      },
    },
  },
  quickActions: {},
};
